const genderOptions = Object.freeze([
  { text: "M.", value: 1, key: "m" },
  { text: "Mme.", value: 2, key: "mme" },
  { text: "M. et Mme", value: 3, key: "m_et_mme" },
  { text: "M. ou Mme", value: 4, key: "m_ou_mme" },
]);

const contactTypeOptions = Object.freeze([
  { text: "Courrier postal", value: 1, key: "courrier_postal" },
  { text: "Email", value: 2, key: "email" },
  { text: "LRE", value: 3, key: "lre" },
  { text: "Remise en main propre", value: 4, key: "remise_en_main_propre" },
]);

const entityTypes = Object.freeze({
  individual: 1,
  legal: 2,
});

export { genderOptions, contactTypeOptions, entityTypes };
